// Lädt die Google Maps JS API einmalig (für öffentliche Seiten ohne die Planer-Komponenten).
let loadingPromise = null;

export const loadGoogleMaps = (libraries = ['geometry']) => {
  if (window.google?.maps) return Promise.resolve(window.google.maps);
  if (loadingPromise) return loadingPromise;
  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=${libraries.join(',')}`;
    script.async = true;
    script.onload = () => resolve(window.google.maps);
    script.onerror = () => {
      loadingPromise = null;
      reject(new Error('Google Maps konnte nicht geladen werden'));
    };
    document.head.appendChild(script);
  });
  return loadingPromise;
};
